import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=f4ae0b9e"
import script from "./RecipientList.vue?vue&type=script&lang=js"
export * from "./RecipientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports